export default __webpack_public_path__ + "static/media/specialist@3x.1431357f.png";